import React from 'react';
import PropTypes from 'prop-types';
import {pageBlockPropType} from '../../../propType/CustomPagePropType';

const CustomPageTopCarouselContentDescription = (props) => {

  let {
    pageBlock,
    pageTypeId
  } = props;

  const descriptionStyle = () => {
    return pageTypeId === '5' ? {margin: "0 2.0rem 2.0rem",paddingTop : "2rem"} : {};
  };

  return (
    <div style={descriptionStyle()}>
      {pageBlock.pageBlockDescriptionHtml &&
      <div className="txt tui-editor-contents clearfix" dangerouslySetInnerHTML={{__html:pageBlock.pageBlockDescriptionHtml}}></div>
      }
    </div>
  );
};

CustomPageTopCarouselContentDescription.propTypes = {
  pageBlock: pageBlockPropType(),
  pageTypeId: PropTypes.string.isRequired,
};

export default CustomPageTopCarouselContentDescription;
